import { gql } from "@apollo/client";
import { skipToken, useSuspenseQuery } from "@apollo/client/react";

import Brand from "./Brand.graphql";

export default function useBrand(id: string) {
    return useSuspenseQuery(
        gql(Brand),
        id
            ? {
                variables: {
                    id,
                },
            }
            : skipToken,
    );
}
